// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__3YHWb","itemTitle":"ClientEmergencyInfo_itemTitle__2gQ6A","itemText":"ClientEmergencyInfo_itemText__1iCg1"};